import { Form,
        Input,Card, Col, Row, Typography,Button,Tooltip, Popconfirm,message, Modal } from "antd";
import React, { useState, useEffect, useRef  } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
  ArrowLeftOutlined,
    DeleteOutlined,
//   UserOutlined,
} from "@ant-design/icons";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SingleUploadAdapter from "../../utils/SingleUploadAdapter";
import subSectionApi, {SubSectionParams, SubSectionResponse, SubSectionDescriptionPatchBody} from '../../services/subSectionApi';
import PageLoader from "../../components/custom/PageLoader";
import Spinner from '../../components/custom/Spinner';

const { Title, Text } = Typography;

const SubsectionPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { sectionId, sectionName, subSectionId, operationName } = location.state || {};
    const [form] = Form.useForm();
    const [description, setDescription] = useState<string>("");
    const [imageList, setImageList] = useState<{ 
        file: File; 
        src: string }[]>
        ([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [saveModal, setSaveModal] = useState<{ open: boolean }>({ open: false });
    const [discardModal, setDiscardModal] = useState<{ open: boolean }>({ open: false });
    const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
    const [isSaving, setIsSaving] = useState(false);

    //const [imagePreview, setImagePreview] = useState<string>("");
    const isAddMode = operationName?.toLowerCase() === "add";
    const isUpdateMode = operationName?.toLowerCase() === "update";
    const editorRef = useRef<any>(null);

    const saveMessageTitle = `Are you sure you want to ${operationName} the subsection?`;
    // Capture image binary from adapter
    useEffect(() => {
        if (!operationName) return;

        const handler = (e: any) => {
            //setImageData(e.detail);
            const { file, src } = e.detail;
            setImageList((prev) => [...prev, { file, src }]);
        };
        window.addEventListener("ckeditor-image-upload", handler);

        const fetchData = async () => {
            if (isUpdateMode) {
                try {
                    await getSubSectionItems(); // your async fetch logic
                } catch (error) {
                    console.error("Failed to fetch subsection items:", error);
                } finally {
                    setIsPageLoading(false); //set loading false regardless of success/fail
                }
            } else {
                setIsPageLoading(false);
            }
        };

        fetchData(); // invoke the async function

        return () => {
            // Cleanup all blob URLs
            imageList.forEach((img) => URL.revokeObjectURL(img.src));
            window.removeEventListener("ckeditor-image-upload", handler);
        };
    }, [operationName]);

      
    const getSubSectionItems = async () => {
        try {
            const subSectionItems: SubSectionResponse[] = await subSectionApi.getSubSection(sectionId);

            const subSectionInfo = subSectionItems.find(item => item.id === subSectionId);

            if (subSectionInfo) {
                form.setFieldsValue({
                    subsectionName: subSectionInfo.name,
                });

                let contentWithImage = subSectionInfo.description || "";
                if (subSectionInfo.fileUrl && !contentWithImage.includes('<img')) {
                    const imageTag = `<p><img src="${subSectionInfo.fileUrl}" alt="${subSectionInfo.fileName}" style="width: 120px;" /></p>`;
                    contentWithImage = imageTag + contentWithImage;
                }

                setDescription(contentWithImage);
                // setDescription(subSectionInfo.description || "");
                // setImagePreview(subSectionInfo.fileUrl || "");
            }

        } catch (error) {
            console.error("Error loading items:", error);
        }
    };
        
    const handleDiscard = async () => {
        
        setDiscardModal({ open: false });
        messageApi.success('Subsection discarded successfully!');
        setTimeout(() => {
                navigate(-1);
            }, 1200);
    };

    const handleRemoveUploadedImage = () => {

        imageList.forEach((img) => URL.revokeObjectURL(img.src));
        setImageList([]);
        setDescription((prev) => prev.replace(/<img\s+[^>]*>/gi, ""));
    };

    const handleSave = async () => {
        const subsectionName = form.getFieldValue("subsectionName");

        // const editorData = editorRef.current?.getData() || "";
        // const editorImages = editorData.match(/<img\s+[^>]*src=["'][^"']+["']/gi) || [];
        // const totalImages = editorImages.length;
        const editorData = editorRef.current?.getData() || "";

        const editorImages = editorData.match(/<img\s+[^>]*src=["'][^"']+["']/gi) || [];
        const totalImages = editorImages.length;

        if (totalImages === 0) {
            messageApi.error('Please upload one image.');
            setSaveModal({ open: false });
            return;
        }

        if (totalImages > 1) {
            messageApi.error('Only one image is allowed. Please remove extra images.');
            setSaveModal({ open: false });
            return;
        }

        // const imageInEditor = /<img\s+[^>]*src=["'][^"']+["']/i.test(description);

        // if (isAddMode && !imageData) {
        //     messageApi.error('Please upload one image.');
        //     return;
        // }

        // if (isUpdateMode && !imageData && !imageInEditor) {
        //     messageApi.error('One image is required. Please upload an image.');
        //     return;
        // }

        try {
            //Hide Modal popup once save is started
            setSaveModal({ open: false });
            setIsSaving(true);

            // Get the currently visible image
            const finalImage = imageList[0];
            
            const params: SubSectionParams = {
                ID: isUpdateMode  ? subSectionId : undefined,
                SectionID: sectionId,
                Name: subsectionName ?? "",
                //SubSectionFile: imageList[0].file,
                Description: description,
                   // ...(imageData?.file && { SubSectionFile: imageData.file })
                   ...(finalImage?.file && { SubSectionFile: finalImage.file }),
                 };
            
            let response : any;
            if(isAddMode){
                response = await subSectionApi.postSubSection(params);
            }
            else if (isUpdateMode) {
                response = await subSectionApi.putSubSection(params);
            }

            messageApi.success(`Subsection ${isAddMode ? `added` : `updated` } successfully!`);
            if(response.fileUrl && finalImage?.file) {
                patchDescriptionFromBlobToImageUrl(response);
            }
            
            setTimeout(() => navigate(-1), 1200);
            //  if (response.status === 200) {
            //         messageApi.success(`Subsection ${isAddMode ? `added` : `updated` } successfully!`);
            //     }

            // const payload = {
            //     subsectionName,
            //     description,
            //     image: imageData
            //         ? {
            //             fileName: imageData.file.name,
            //             mimeType: imageData.file.type,
            //             base64: imageData.base64Data.split(",")[1], // remove prefix
            //         }
            //         : null,
            // };
        } catch (err) {
            const apiErrorMessage = err?.response?.data?.Message;
            messageApi.error(apiErrorMessage || 'Something went wrong');
            console.error("Failed to save subsection:", err);
        }
        finally{
            setIsSaving(false);
            // setTimeout(() => {
            //     navigate(-1);
            // }, 1200);
        }
    };

    const patchDescriptionFromBlobToImageUrl = ( responseData: any ) => {
           
            const updatedDescription = responseData.description.replace(
                /src="blob:[^"]+"/, // regex to find blob src
                `src="${responseData.fileUrl}"` // replace with fileUrl
            );

            const descriptionPatchBody : SubSectionDescriptionPatchBody = {
            id: responseData.id,
            description : updatedDescription,
            };

            const startTime = performance.now(); 
            subSectionApi.patchSubSectionDescription(descriptionPatchBody);
            const endTime = performance.now(); 
            console.log("API call ended patch subsection desc", new Date().toISOString(), 
            "| Duration:", (endTime - startTime).toFixed(2), "ms");
            //console.log("PUT BODY", JSON.stringify(descriptionPatchBody, null, 2));
            
     };

    return (
        <div>
            {contextHolder}

        {
        isPageLoading && (
          <PageLoader />
        )}

        <Modal
          title="Are you sure you want to discard the subsection?"
          open={discardModal.open}
          onOk={() => handleDiscard()}
          onCancel={() => setDiscardModal({ open: false })}
          okText="Yes"
          cancelText="No"
          centered
          okButtonProps={{
            style: styles.okButton,
            type: "default",
        }}
        />

        <Modal
          title={saveMessageTitle}
          open={saveModal.open}
          onOk={() => handleSave()}
          onCancel={() => setSaveModal({ open: false })}
          okText="Yes"
          cancelText="No"
          centered
          okButtonProps={{
            style: styles.okButton,
            type: "default",
          }}
        />
            {/* Header */}
            <div style={{ marginBottom: "40px" }}>
                <Title level={3} style={{ color: "#41787C" }}>
                    <Button
                        type="link"
                        icon={
                            <ArrowLeftOutlined
                                style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#000",
                                    marginRight: 10,
                                }}
                            />
                        }
                        onClick={() => navigate(-1)}
                        style={{
                            marginBottom: "10px",
                            padding: 0,
                            color: "#41787C",
                        }}
                    />
                    {sectionName || "Subsection"}
                </Title>
            </div>

            {/* Form */}
            <Form form={form} layout="vertical">
                {/* Subsection Name */}
                <Form.Item
                    name="subsectionName"
                    label="Subsection Name"
                //rules={[{ required: true, message: "Please enter subsection name" }]}
                style={styles.label}
                >
                <Input placeholder="Enter subsection name" style={styles.input} />
                </Form.Item>

                {/* Description */}
                <Form.Item label="Description">
                    <CKEditor
                        editor={ClassicEditor as any}
                        data={description} // ✅ This is critical for showing text + image
                        config={{
                            placeholder: "Enter description",
                            toolbar: [
                                "heading", "|",
                                "bold", "italic", "link", "bulletedList", "numberedList", "|",
                                "blockQuote", "undo", "redo", "imageUpload",
                                "imageStyle:alignLeft", "imageStyle:alignCenter", "imageStyle:alignRight", "imageStyle:full",
                                "alignment",
                            ],
                            image: {
                                toolbar: [
                                    "imageStyle:alignLeft",
                                    "imageStyle:alignCenter",
                                    "imageStyle:alignRight",
                                    "imageStyle:full",
                                        "imageTextAlternative",
                                ],
                                resizeUnit: "%",
                                resizeOptions: [
                                    { name: "resizeImage:original", label: "Original", value: null },
                                    { name: "resizeImage:25", label: "25%", value: "25" },
                                    { name: "resizeImage:50", label: "50%", value: "50" },
                                    { name: "resizeImage:75", label: "75%", value: "75" }
                                ]
                            },
                        }}
                        onReady={(editor) => {
                            editorRef.current = editor;
                            editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
                                return new SingleUploadAdapter(loader);
                            };
                        }}
                        // onChange={(_, editor) => {
                        //     const data = editor.getData() || "";
                        //     //const textOnly = data.replace(/<img[^>]*>/g, "").trim();
                        //     setDescription(data); // ✅ Use raw HTML, not textOnly
                        // }}
                        
                        onChange={(_, editor) => {
                            const data = editor.getData() || "";
                            setDescription(data);

                            // Extract all <img src="..."> from current editor HTML
                            const imgSrcs = Array.from(
                                data.matchAll(/<img\s+[^>]*src=["']([^"']+)["']/gi)
                            ).map((m) => m[1]);

                            // Sync imageList safely using setImageList callback
                            setImageList((prev) => {
                                // Revoke blob URLs that were removed from editor content
                                prev.forEach((img) => {
                                    if (!imgSrcs.includes(img.src)) URL.revokeObjectURL(img.src);
                                });

                                // Keep only images that still exist in the editor
                                return prev.filter((img) => imgSrcs.includes(img.src));
                            });
                        }}
                    />
                    {/* {imagePreview && isUpdateMode && (
                        <div style={{ marginTop: 12 }}>
                            <img
                                src={imagePreview}
                                alt="Preview"
                                style={{ width: 120, height: 120, objectFit: "cover", borderRadius: 8 }}
                            />
                        </div>
                    )} */}
                    {/* Editor styling */}
                    <style>
                        {`
              .ck-editor__editable_inline {
                min-height: 200px;
                max-height: 200px;
                overflow-y: auto;
              }
              .ck-content img {
                width: 200px !important;
                height: 200px !important;
                object-fit: contain;
                float: left;
                margin: 0 auto !important;
              }
                /* Hide CKEditor watermark */
              .ck-powered-by {
                display: none !important;
              }
              .ck-powered-by-ckeditor {
                 display: none !important;
              }
               /* Alternative selectors for different CKEditor versions */
              [class*="ck-powered-by"] {
                 display: none !important;
              }
               .ck-editor__main .ck-powered-by {
                 display: none !important;
               }
            `}
                    </style>
                </Form.Item>

                {/* Action Buttons */}
                <div style={styles.buttonRow}>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="default" style={styles.whiteButton} 
                    onClick={() => setDiscardModal({ open: true })}>
                    Discard
                    </Button>
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="primary" htmlType="submit" 
                    onClick={() => setSaveModal({ open: true })}
                    disabled={isSaving}
                    style={styles.greenButton}>
                        {isSaving && <Spinner />}
                        {isSaving ? 'Saving...' : 'Save'}
                    </Button>
                </Form.Item>
                </div>
            </Form>
        </div>
    );
};

export default SubsectionPage;

const baseGreen = '#3E767A';
const hoverGreen = '#5B9492';
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
  },
  label: {
    color: '#3E767A',
    fontSize: '20px',
    marginBottom: '15px',
    fontWeight: 630,
    textAlign: 'left',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '16px',
    borderRadius: '8px',
    border: '1px solid #d9d9d9',
    background: '#F9F9FA 0% 0% no-repeat padding-box',
    outline: 'none',
  },
//   textarea: {
//     width: '100%',
//     padding: '10px 12px',
//     fontSize: '16px',
//     borderRadius: '8px',
//     border: '1px solid #d9d9d9',
//     background: '#F9F9FA 0% 0% no-repeat padding-box',
//     outline: 'none',
//     resize: 'vertical',
//   },
  whiteButton :
	{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: "8px 24px",
    fontSize: '13px',
    borderRadius: '20px',
    border: `2px solid #f1f2f4`,
    color: baseGreen,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: '#f1f2f4',
    // width: '120px',
    // height: '37px',
    minWidth: "140px",
    boxShadow: '0 2px 0 #FAFAFA',
    transform: 'translateY(2px)',
    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  },
  greenButton :
	{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: "8px 16px",
    fontSize: '13px',
    borderRadius: '20px',
    border: `2px solid ${baseGreen}`,
    color: '#F1F2F4',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: baseGreen,
    fontWeight: 600,
    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '30px',
  },
  okButton: {
    backgroundColor: "#3E767A",
    borderColor: "#3E767A",
    color: "#fff",
  },
};
